export const validateAlphabets = (input) => {
  let pattern = new RegExp(/^[A-Za-z]$/)
  return pattern.test(input) ? true : false
}

export const validateAlphaNumerics = (input) => {
  let pattern = new RegExp(/[A-Za-z0-9]$/)
  return pattern.test(input) ? true : false
}

export const validateEmail = (input) => {
  let pattern = new RegExp(
    /^[A-z0-9_-]+(?:\.[A-z0-9_-]+)*@[A-z0-9-]+(?:\.[A-z0-9-]+)*\.[A-z]{2,6}$/,
  )
  return pattern.test(input) ? true : false
}

export const validatePhoneNumber = (input) => {
  // /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/
  let pattern = new RegExp(/^[0-9]{10,10}$/)
  return pattern.test(input) ? true : false
}

export const validateURL = (url) => {
  /*
    (1) ^                               : Start of the string
    (2) (?:https?|ftp):\/\/             : Matches the protocol (http, https, ftp)
    (3) (?:localhost|\d{1,3}(?:\.\d{1,3}){3}|(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,})+)  : Matches the domain or IP address
    (4) (?::\d{1,5})?                   : Matches an optional port number
    (5) (?:\/[^\s<>"{}|\\^`\[\]%]|%[0-9A-Fa-f]{2})*    : Matches an optional path with percent-encoded characters
    (6) (?:\?[^\s<>"{}|\\^`\[\]]*)?     : Matches an optional query string
    (7) (?:#[^\s<>"{}|\\^`\[\]]*)?      : Matches an optional fragment identifier
    (8) |file:\/\/\/(?:[a-zA-Z]         :[\\\/]|\/)[^\s<>"{}|\\^`\[\]]* : Matches a file URL
    (9) $                               : End of the string
  */
  const pattern = /^(?:(https?|ftp):\/\/(?:localhost|\d{1,3}(?:\.\d{1,3}){3}|(?:www\.)?[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]{2,})+)(?::\d{1,5})?(?:\/(?:[^\s<>"{}|\\^`\[\]%]|%[0-9A-Fa-f]{2})*)?(?:\?[^\s<>"{}|\\^`\[\]]*)?(?:#[^\s<>"{}|\\^`\[\]]*)?|file:\/\/\/(?:[a-zA-Z]:[\\\/]|\/)[^\s<>"{}|\\^`\[\]]*)$/;

  // Check if the pattern matches
  if (!pattern.test(url)) {
    return false;
  }

  // Reject dangerous characters explicitly
  const dangerousChars = /[<>{}"'`\\|^@]/;
  if (dangerousChars.test(url)) {
    return false;
  }

  return true;
}
